import { css } from "styled-components";
import ContentLoader from "react-content-loader";

const Rightbox = (props) => (
  <ContentLoader
    speed={2}
    width={367}
    height={143}
    viewBox="0 0 367 143"
    backgroundColor="#cad5e4"
    foregroundColor="#D5E1F0"
    {...props}
  >
    <path d="M 0 0 h 181 v 143 H 0 z M 186 0 h 181 v 143 H 186 z" />
  </ContentLoader>
);

const LeftDetail = (props) => (
  <ContentLoader
    speed={2}
    width={389}
    height={101}
    viewBox="0 0 389 101"
    backgroundColor="#cad5e4"
    foregroundColor="#D5E1F0"
    {...props}
  >
    <path d="M 1 0 h 48 v 16 H 1 z M 0 23 h 291 v 26 H 0 z M 2 63 h 65 v 18 H 2 z M 246 63 h 113 v 18 H 246 z M 2 89 h 143 v 12 H 2 z M 246 89 h 143 v 12 H 246 z" />
  </ContentLoader>
);

const JobInfoSkeleton = () => (
  <div
    css={`
      display: flex;
      justify-content: space-between;
      width: 100%;
    `}
  >
    <LeftDetail /> <Rightbox />
  </div>
);

export const TagSkeleton = (props) => (
  <ContentLoader
    speed={2}
    width={48}
    height={16}
    viewBox="0 0 48 16"
    backgroundColor="#cad5e4"
    foregroundColor="#D5E1F0"
    {...props}
  >
    <path d="M 0 0 h 48 v 16 H 0 z" />
  </ContentLoader>
);

export default JobInfoSkeleton;
